import Accordions from './Accordions';
import Buttons from './Buttons';
import CTA from './CTA';
import Cards from './Cards';
import Columns from './Columns';
import FeatureTiles from './FeatureTiles';
import Image from './Image';
import Links from './Links';
import Message from './Message';
import Quote from './Quote';
import Richtext from './Richtext';
import Slider from './Slider';
import Table from './Table';
import Team from './Team';

const streamfields = {
  cta: CTA,
  links: Links,
  message: Message,
  full_richtext: Richtext,
  simple_richtext: Richtext,
  table: Table,
  cards: Cards,
  slider: Slider,
  accordion: Accordions,
  image: Image,
  quote: Quote,
  columns: Columns,
  feature_tiles: FeatureTiles,
  buttons: Buttons,
  team: Team,
};

export type Streamfields = keyof typeof streamfields;

export default streamfields;
